import styled from "styled-components";

export const PartnersContainers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
  margin: 25px 0px;
  gap: 30px;

  @media ${({ theme }) => theme.devices.laptop} {
    grid-column: auto / span 5;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    grid-column: auto / span 3;
  }
  @media ${({ theme }) => theme.devices.tabletS} {
    grid-column: auto / span 1;
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    margin-top: 15px;
    grid-column: auto / span 2;
  }
`;
export const PartnersTitle = styled.p`
  color: #fff;
  margin: 0;
  padding: 0;
  font-size: ${({ theme }) => theme.fontSizePx.md2};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 500;
  line-height: 29px;
`;

export const LogosContainer = styled.div`
  display: flex;
  gap: 48px;

  @media ${({ theme }) => theme.devices.tablet} {
    gap: 24px;
    flex-direction: column;
    margin-bottom: 48px;
  }
`;

export const PartnersContent = styled.div`
  display: flex;
  gap: 56px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const CEIALogo = styled.img`
  max-width: 240px;
  max-height: 140px;
`;
export const UFGLogo = styled.img`
  max-width: 180px;
  max-height: 100px;
`;

export const EmbrapiiLogo = styled.img`
  max-width: 180px;
  max-height: 80px;
`;
export const SebraeLogo = styled.img`
  max-width: 180px;
  max-height: 100px;
`;
